import { z } from 'zod';
import { ALLERGENS, ALL_UNITS } from '@mise/domain';

/** Shared primitives. Every id in the system is a UUID generated by Postgres. */
export const idSchema = z.uuid();

/**
 * Units and allergens come straight from the domain package, so adding a unit
 * there is enough to make the API accept it.
 */
export const unitCodeSchema = z.enum(ALL_UNITS.map((u) => u.code));
export const allergenSchema = z.enum(ALLERGENS);

/** A quantity as a chef entered it: a number and the unit they chose. */
export const quantitySchema = z.object({
  value: z.number().finite().nonnegative(),
  unit: unitCodeSchema,
});

export const paginationSchema = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});

/** The shape every failed request comes back in. */
export const errorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});

export type Quantity = z.infer<typeof quantitySchema>;
export type ApiError = z.infer<typeof errorSchema>;
